import { Injectable } from "@angular/core";
import { AllowListAuthStore } from "./allow-list-auth.store";

@Injectable({
    providedIn: 'root'
})
export class AuthorizationUtility {

    constructor(private allowListStore: AllowListAuthStore) {}

    // -----------------------------------------------------------------------
    // Action / Button / Tab visibility — delegates to AllowListAuthStore
    // -----------------------------------------------------------------------

    public isRestrictiedAction(pageId: string, action: string): boolean {
        return !this.allowListStore.isActionAllowed(pageId, action);
    }

    public isTabVisible(pageId: string, tabTitle: string): boolean {
        return this.allowListStore.isTabAllowed(pageId, tabTitle);
    }

    public isButtonVisible(pageId: string, buttonLabel: string): boolean {
        return this.allowListStore.isButtonAllowed(pageId, buttonLabel);
    }

    // -----------------------------------------------------------------------
    // Field / Section level checks
    // -----------------------------------------------------------------------

    public isFieldReadable(pageId: string, tabId: string, sectionName: string, _fieldLabel: string): boolean {
        return this.allowListStore.isSectionVisible(pageId, tabId, sectionName);
    }

    public isFieldEditable(pageId: string, tabId: string, sectionName: string, _fieldLabel: string): boolean {
        return this.allowListStore.isSectionEditable(pageId, tabId, sectionName);
    }

    public isFieldDeletable(pageId: string, tabId: string, sectionName: string, _fieldLabel: string): boolean {
        return this.allowListStore.isSectionDeletable(pageId, tabId, sectionName);
    }

    public isSectionVisible(pageId: string, tabId: string, sectionName: string): boolean {
        return this.allowListStore.isSectionVisible(pageId, tabId, sectionName);
    }

    public isSectionEditable(pageId: string, tabId: string, sectionName: string): boolean {
        return this.allowListStore.isSectionEditable(pageId, tabId, sectionName);
    }

    public isSectionDeletable(pageId: string, tabId: string, sectionName: string): boolean {
        return this.allowListStore.isSectionDeletable(pageId, tabId, sectionName);
    }

    // -----------------------------------------------------------------------
    // Allowed lists
    // -----------------------------------------------------------------------

    public isTabEditable(pageId: string, tabId: string): boolean {
        return this.allowListStore.isTabEditable(pageId, tabId);
    }

    public getAllowedActions(pageId: string): string[] {
        return this.allowListStore.getAllowedActions(pageId);
    }

    public getAllowedButtons(pageId: string): string[] {
        return this.allowListStore.getAllowedButtons(pageId);
    }

    public getAllowedColumns(pageId: string): string[] {
        return this.allowListStore.getAllowedColumns(pageId);
    }

    public getAllowedTabs(pageId: string): string[] {
        return this.allowListStore.getAllowedTabs(pageId);
    }
}
